export const articleData: Record<string, {
  id: string;
  title: string;
  category: string;
  date: string;
  views: string;
  comments: string;
  heroImage: string;
  author: { name: string; avatar: string; role: string };
  content: string[];
  relatedArticles: Array<{
    id: string;
    title: string;
    category: string;
    imageUrl: string;
    date: string;
    views: string;
  }>;
  articleComments: Array<{
    id: string;
    name: string;
    avatar: string;
    date: string;
    content: string;
    likes: string;
    replies?: Array<{
      id: string;
      name: string;
      avatar: string;
      date: string;
      content: string;
      likes: string;
    }>;
  }>;
}> = {
  '1': {
    id: '1',
    title: '某顶流网红深夜发长文道歉，承认与多位女粉丝存在不当关系',
    category: '网红爆料',
    date: '2026-07-07',
    views: '128.6万',
    comments: '3.2万',
    heroImage: 'https://readdy.ai/api/search-image?query=apology%20letter%20on%20smartphone%20screen%20in%20dark%20room%2C%20dramatic%20moody%20lighting%2C%20social%20media%20scandal%20concept%2C%20warm%20tone%2C%20editorial%20photography%2C%20clean%20background%2C%20high%20detail%2C%20emotional%20atmosphere&width=1200&height=700&seq=article-hero-01&orientation=landscape',
    author: { name: '黑料编辑部', avatar: 'https://readdy.ai/api/search-image?query=editorial%20team%20logo%20style%20portrait%20of%20news%20journalist%2C%20professional%20warm%20lighting%2C%20clean%20background%2C%20editorial%20photography%2C%20high%20quality&width=120&height=120&seq=author-editor&orientation=squarish', role: '资深编辑' },
    content: [
      '近日，知名网红"某某"（化名）在个人社交平台发布了一篇长达三千字的长文，就此前被媒体曝光的多起私生活问题向公众正式道歉。这篇长文发布后仅一小时，阅读量就突破了五千万，相关话题迅速登顶热搜榜。',
      '在这篇道歉长文中，该网红承认自己"在过去的两年里，确实与多位女粉丝保持了不当的亲密关系"，并表示"深感愧疚和自责"。他还提到，自己"辜负了粉丝的信任和支持，也伤害了那些被卷入其中的无辜女性"。',
      '据知情人士透露，这篇道歉长文的发布并非偶然。此前一周，多家娱乐媒体已经掌握了大量关于该网红的私生活爆料素材，并计划在近期陆续发布。面对即将到来的舆论风暴，该网红团队选择了主动道歉的策略。',
      '然而，这篇道歉长文并未获得网友的普遍认可。不少网友指出，文中多处措辞含糊其辞，对关键问题的回应避重就轻。有网友评论道："说了半天，具体和几个人、什么时候开始、有没有欺骗感情，全都没说清楚。"',
      '事件发酵后，与该网红有商业合作的多个品牌方也迅速做出了反应。据统计，至少有五家品牌已经在社交平台删除了与该网红相关的推广内容，其中两家品牌明确表示"已终止合作关系"。',
      '业内人士分析认为，此次事件对该网红的商业价值将造成重大打击。根据行业数据估算，该网红每年通过直播带货和品牌代言获得的收入超过五千万，而如今这些收入来源可能面临全面中断的风险。',
      '截至目前，该网红已关闭了社交平台的评论功能，并表示将"暂时退出公众视野，认真反思自己的行为"。但其团队尚未就后续工作安排给出明确回应。黑料在线将持续关注此事的后续发展。'
    ],
    relatedArticles: [
      { id: 'm1', title: '某品牌已紧急下架涉事网红所有代言产品', category: '网红爆料', imageUrl: 'https://readdy.ai/api/search-image?query=empty%20shopping%20mall%20display%20with%20removed%20posters%2C%20commercial%20space%2C%20warm%20lighting%2C%20editorial%20photography%2C%20clean%20background%2C%20high%20detail&width=800&height=600&seq=rel-01&orientation=landscape', date: '2026-07-07', views: '45.2万' },
      { id: 'm3', title: '直播带货翻车现场！大主播涉嫌虚假宣传被粉丝集体投诉', category: '直播翻车', imageUrl: 'https://readdy.ai/api/search-image?query=live%20streaming%20studio%20with%20red%20warning%20lighting%2C%20social%20media%20controversy%2C%20warm%20tone%2C%20editorial%20photography%2C%20clean%20background%2C%20high%20detail&width=800&height=600&seq=rel-02&orientation=landscape', date: '2026-07-05', views: '85.7万' },
    ],
    articleComments: [
      {
        id: 'c1',
        name: '吃瓜第一线',
        avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20person%20portrait%20with%20casual%20style%2C%20warm%20lighting%2C%20friendly%20expression%2C%20clean%20background%2C%20editorial%20portrait%2C%20high%20quality&width=120&height=120&seq=cmt-01&orientation=squarish',
        date: '17分钟前',
        content: '笑死，这就叫"道歉"？连具体做了什么都说不清楚，还不如不道歉呢。建议直接退网算了。',
        likes: '2.3万',
        replies: [
          { id: 'cr1', name: '路人甲看热闹', avatar: 'https://readdy.ai/api/search-image?query=young%20Asian%20man%20portrait%2C%20warm%20lighting%2C%20neutral%20expression%2C%20clean%20background%2C%20editorial%20portrait%2C%20high%20quality&width=120&height=120&seq=cmt-reply-01&orientation=squarish', date: '12分钟前', content: '说得对，道歉要真诚才有用，这种模棱两可的话术谁看不出来啊', likes: '856' },
        ]
      },
      {
        id: 'c2',
        name: '娱乐圈观察员',
        avatar: 'https://readdy.ai/api/search-image?query=middle%20aged%20Chinese%20woman%20portrait%2C%20professional%20look%2C%20warm%20lighting%2C%20clean%20background%2C%20editorial%20portrait%2C%20high%20quality&width=120&height=120&seq=cmt-02&orientation=squarish',
        date: '32分钟前',
        content: '其实这个时间点发道歉文很聪明，肯定是团队商量好的。但问题是内容太敷衍了，反而激化了矛盾。公关团队该反思了。',
        likes: '1.8万',
      },
      {
        id: 'c3',
        name: '深夜吃瓜人',
        avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20man%20portrait%20with%20glasses%2C%20warm%20lighting%2C%20thoughtful%20expression%2C%20clean%20background%2C%20editorial%20portrait%2C%20high%20quality&width=120&height=120&seq=cmt-03&orientation=squarish',
        date: '1小时前',
        content: '据我所知，后面还有更大的料要爆。这次道歉只是个开头，后面估计还有好几波。大家准备好瓜子板凳吧！',
        likes: '3.1万',
        replies: [
          { id: 'cr2', name: '瓜田守望者', avatar: 'https://readdy.ai/api/search-image?query=young%20Asian%20woman%20portrait%2C%20warm%20lighting%2C%20curious%20expression%2C%20clean%20background%2C%20editorial%20portrait%2C%20high%20quality&width=120&height=120&seq=cmt-reply-02&orientation=squarish', date: '55分钟前', content: '真的假的？还有什么料快说说，别卖关子！', likes: '1.2万' },
          { id: 'cr3', name: '深夜吃瓜人', avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20man%20portrait%2C%20warm%20lighting%2C%20mysterious%20smile%2C%20clean%20background%2C%20editorial%20portrait%2C%20high%20quality&width=120&height=120&seq=cmt-reply-03&orientation=squarish', date: '48分钟前', content: '不敢说太细，但下周你们就知道了，绝对劲爆', likes: '980' },
        ]
      },
    ]
  }
};

export const defaultArticleData = {
  id: 'default',
  title: '文章详情',
  category: '综合爆料',
  date: '2026-07-07',
  views: '10.2万',
  comments: '2568',
  heroImage: 'https://readdy.ai/api/search-image?query=news%20article%20concept%20with%20dramatic%20lighting%2C%20warm%20tone%2C%20editorial%20photography%2C%20clean%20background%2C%20high%20detail%2C%20professional%20journalism%20style&width=1200&height=700&seq=article-hero-default&orientation=landscape',
  author: { name: '黑料编辑部', avatar: 'https://readdy.ai/api/search-image?query=news%20editor%20portrait%2C%20warm%20lighting%2C%20clean%20background%2C%20editorial%20portrait%2C%20high%20quality&width=120&height=120&seq=author-default&orientation=squarish', role: '编辑' },
  content: ['文章内容加载中...'],
  relatedArticles: [],
  articleComments: []
};